import { ReportHealthDetailRecorderAlert } from "api/interfaces/reportInterface.interface";
import * as s from "./SystemSpecStyled";
import SystemSpectrumSpec from "./spectrum/SystemSpectrumSpec";
import SystemVMAXSpec from "./vmax";

type Props = {
  recorderId: string;
  type: string;
  brand?: string;
  isSystemNotResponding?: ReportHealthDetailRecorderAlert | null;
};

export default function SystemSpecs(props: Props): JSX.Element {
  return (
    <s.Wrapper>
      {props.type === "Spectrum" ? (
        <SystemSpectrumSpec recorderId={props.recorderId} />
      ) : (
        <SystemVMAXSpec
          recorderId={props.recorderId}
          brand={props.brand}
          isSystemNotResponding={props.isSystemNotResponding}
        />
      )}
    </s.Wrapper>
  );
}
